import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetOversightAssessmentCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetOversightAssessmentCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    oversight_assessment_aggregate: {
      aggregate: toAggregate(data.oversightAssessment),
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetOversightAssessmentCountDocument,
});
